(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-store-header]').forEach(header => {
      if (header.dataset.navReady) return;
      header.dataset.navReady = 'true';
      const dialog = header.querySelector('[data-store-search]');
      const open = header.querySelector('[data-search-open]');
      const close = header.querySelector('[data-search-close]');
      const menu = header.querySelector('[data-store-menu]');
      const setScroll = () => {
        document.documentElement.style.overflow = menu?.open || dialog?.open ? 'hidden' : '';
      };
      open?.addEventListener('click', () => {
        if (menu) menu.open = false;
        dialog?.showModal();
        setScroll();
        dialog?.querySelector('input[type="search"]')?.focus();
      });
      close?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('close', () => {
        setScroll();
        open?.focus();
      });
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientY > rect.bottom || event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) dialog.close();
      });
      menu?.addEventListener('toggle', () => {
        menu.style.setProperty('--store-menu-top', `${header.getBoundingClientRect().bottom}px`);
        setScroll();
        if (menu.open) menu.querySelector('nav a')?.focus();
      });
      header.querySelector('[data-menu-close]')?.addEventListener('click', () => {
        if (menu) menu.open = false;
        menu?.querySelector('summary')?.focus();
      });
      menu?.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {
        menu.open = false;
        setScroll();
      }));
      header.querySelectorAll('[data-store-language]').forEach(select => select.addEventListener('change', () => select.form?.submit()));
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu?.open) {
          menu.open = false;
          menu.querySelector('summary')?.focus();
        }
        if (event.key === 'Tab' && menu?.open) {
          const controls = [...menu.querySelectorAll('.store-menu-panel button, .store-menu-panel a')];
          const first = controls[0];
          const last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
        }
      });
      const desktop = window.matchMedia('(min-width: 901px)');
      desktop.addEventListener('change', event => {
        if (event.matches && menu) {
          menu.open = false;
          setScroll();
        }
      });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
